module.exports = __webpack_public_path__ + "img/especialista5.0185fe4c.png";